export default __webpack_public_path__ + "static/media/eigenheim_icons_ruler.f89a158a.svg";